import { ApiDataAdapter } from '@internal-libraries/kheops-ui-lib'
import { get } from 'lodash'
import ClvrAdmissionType from '../Classes/ClvrAdmissionType'
import { AdmissionTypeDto } from '../Type/AdmissionTypeDto'

export class AdmissionTypeApiAdapter implements ApiDataAdapter<ClvrAdmissionType> {
    public createClass(apiData: AdmissionTypeDto): ClvrAdmissionType {
        return new ClvrAdmissionType({
            id: get(apiData, 'id', null),
            label: get(apiData, 'label'),
        })
    }
}
